/* eslint-disable global-require */

import angular from 'angular';
import './document-wrap.styles.scss';

export default angular.module('directives.abDocumentWrap', [])
  .directive('documentWrap', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        documentIds: '=', // array of all document id's to display
      },
      templateUrl: require('./document-wrap.template.html'),
    };
  })
  .name;
